var $f510599a6178d1bd$exports = {};
$f510599a6178d1bd$exports = {
  "backButton": args => `Nazaj na ${args.prevMenuButton}`,
  "moreActions": `Ve\u{10D} mo\u{17E}nosti`,
  "unavailable": `Ni na voljo, raz\u{161}irite za podrobnosti`
};
export { $f510599a6178d1bd$exports as default };